{
  "shellWaitLabel": "正在加载"
}
